import React from 'react';

export default function Header() {
  return (
    <div>
      <h1 className="heading">da coolest expense tracker</h1>
    </div>
  );
}
